import { fetchPicSearchData } from '@components/PicSearch/picSearchService';
import { APP_MESSAGES_QUERY_KEY, fetchAppMessages } from '@services/app-messages';
import React, { useEffect } from 'react';
import { useQueryClient } from 'react-query';

interface DataPrefetcherProps {
    children: React.ReactNode;
}

const DataPrefetcher: React.FC<DataPrefetcherProps> = ({ children }) => {
    const queryClient = useQueryClient();

    useEffect(() => {
        // Prefetch all the queries we want warmed up

        // Prefetch PIC Search Data
        queryClient.prefetchQuery('pic-search-data', fetchPicSearchData);

        // Prefetch contextual App_Messages banners (ENVDB-7836) so they are warm before the wizard opens
        queryClient.prefetchQuery(APP_MESSAGES_QUERY_KEY, fetchAppMessages);
    }, [queryClient]);

    return <>{children}</>;
};

export default DataPrefetcher;
